<div class="mt-3"></div>
<h1 class="text-center">{{'MESSAGE.PLEASE_WAIT' | translate}}</h1>
<app-loading-spinner [loading]="true" class="mt-4"></app-loading-spinner>
